// Hero slider: Slick Carousel with autoplay + pause-on-hover + a "01/03"
// counter Slick doesn't render natively, updated from the afterChange callback.
// Uses the bare `$` global (provided by webpack.config.js's ProvidePlugin,
// same as home.js) — NOT window.jQuery, which is a separate, non-slick-patched
// jQuery instance loaded by WordPress core (see wp_enqueue_script('jquery')).

function init() {
    $('.hero-slider__viewport').each(function () {
        const $viewport = $(this);
        if ($viewport.hasClass('slick-initialized')) return;

        const $counter = $viewport.closest('.hero-slider').find('[data-hero-slider-counter]');
        const total = $viewport.find('.hero-slider__slide').length;

        function updateCounter(index) {
            if (!$counter.length) return;
            $counter.text(String(index + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0'));
        }

        $viewport.on('init', (e, slick) => updateCounter(slick.currentSlide));
        $viewport.on('afterChange', (e, slick, currentSlide) => updateCounter(currentSlide));

        $viewport.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 0, // disable Slick's grid-row wrapper — it forces display:inline-block
                     // inline on each slide, which fights our own flex layout inside it
            fade: true,
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 6500,
            pauseOnHover: true,
            infinite: true,
        });
    });
}

export default { init };
